module.exports = __webpack_public_path__ + "static/pets_heropack@2x-896c1de07057c265ed3c92d6bfe1f249.png";